import http from "./httpService";
import tokenStorage from "./tokenStorage";

const runtimeConfig = window.__APP_CONFIG__ || {};

const AUTH_SYSTEM_CLIENT_ID =
    runtimeConfig.AUTH_SYSTEM_CLIENT_ID ||
    process.env.REACT_APP_AUTH_SYSTEM_CLIENT_ID;

const AUTH_SYSTEM_CLIENT_SECRET = process.env.REACT_APP_AUTH_SYSTEM_CLIENT_SECRET;

export const AUTH_SYSTEM_URL =
    runtimeConfig.AUTH_SYSTEM_URL ||
    process.env.REACT_APP_AUTH_SYSTEM_URL;

const getBearerTokenAuth = () => ({ headers: { Authorization: `Bearer ${tokenStorage.getAuthToken()}` } });
export const getClientAuth = () => ({
    auth: {
        username: AUTH_SYSTEM_CLIENT_ID,
        password: AUTH_SYSTEM_CLIENT_SECRET,
    }
});

const getAuthToken = async (code) => {
    const formData = new FormData();
    formData.append("grant_type", "authorization_code");
    formData.append("code", code);
    formData.append("redirect_uri", `${window.location.protocol}//${window.location.hostname}/callback`);

    const { data } = await http.post(`${AUTH_SYSTEM_URL}/oauth/token`, formData, getClientAuth());

    return data;
};

export const introspectToken = (token, callback) => {
    if (!token) return false;
    const formData = new FormData();
    formData.append('token', token);
    http.post(`${AUTH_SYSTEM_URL}/oauth/introspect`, formData, getClientAuth()).then(
        ({ data }) => callback(data),
    );
};

export const refreshAuthToken = () => {
    const token = tokenStorage.getRefreshToken();
    return refreshToken(token).then(
        ({ data }) => tokenStorage.setAuthToken(data),
        error => {
            tokenStorage.eraseTokens();
            throw error;
        }
    );
};

const refreshToken = (token) => {
    const formData = new FormData();
    formData.append("grant_type", "refresh_token");
    formData.append("refresh_token", token);
    return http.post(`${AUTH_SYSTEM_URL}/oauth/token`, formData, getClientAuth());
};

export const getAccessToken = (code) => {
    return getAuthToken(code).then(data => tokenStorage.setAuthToken(data));
};

export const login = (username) => {
    const returnUri = `${window.location.protocol}//${window.location.hostname}/callback`;
    const queryString = `response_type=code&client_id=${AUTH_SYSTEM_CLIENT_ID}&redirect_uri=${returnUri}&login_hint=${username}&scope=openid`;

    window.location.replace(`${AUTH_SYSTEM_URL}/oauth/authorize?${queryString}`);
};

export const getCurrentUser = () => {
    try {
        return tokenStorage.getAuthToken();
    } catch (error) {
        return null;
    }
};

export const signOutUser = async () => {
    tokenStorage.eraseTokens();
    // placeholder for sign out api call
};

export const getUserInfo = async () => {
    const { data } = await http.get(`${AUTH_SYSTEM_URL}/userinfo`, getBearerTokenAuth());
    return data;
};

export const getApplications = async () => {
    const { data } = await http.get(`${AUTH_SYSTEM_URL}/sso/connections`, getBearerTokenAuth());
    return data;
};

export const getSSOToken = async (applicationUuid) => {
    const formData = new FormData();
    formData.append("service", applicationUuid);
    const { data } = await http.post(`${AUTH_SYSTEM_URL}/sso/token`, formData, getBearerTokenAuth());
    return data;
};

export const refreshSSOToken = async (applicationUuid) => {
    const token = tokenStorage.getSSORefreshToken(applicationUuid);
    return refreshToken(token).then(
        ({ data }) => tokenStorage.setSSOToken(applicationUuid, data),
        error => {
            tokenStorage.eraseSSOToken(applicationUuid);
            throw error; // escalate error
        }
    );
};

export const getMfaMethods = async () => {
    const { data } = await http.get(`${AUTH_SYSTEM_URL}/mfa/methods`, getClientAuth());
    return data;
};


const authService = {
    login,
    getAccessToken,
    getCurrentUser,
    getUserInfo,
    getApplications,
    getMfaMethods,
    getSSOToken,
    signOutUser
};

export default authService;
